var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BlockUI',[_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x fa-fw"})])
}
var staticRenderFns = []

export { render, staticRenderFns }